let slickDefaults = require('../slick-default/slick-default');
require('./digest.less');

jQuery(function() {
    $('.js-digest-mini-slider').each(function() {
        var $this = $(this);

        $this.slick(
            $.extend({}, slickDefaults.params, {
                slidesToShow: 1
            })
        );
    });

    if ($('#section_descr').html()) {
        $('.js-scroll-link').removeClass('digest__more-link-hidden');
    }

    $('.js-digest-video-popup').click(function() {
        let $this = $(this);
        let videoType = $this.data('type');
        let videoSrc = $this.data('src');
        let sectId = $this.data('id');
        if (videoType === 'remote') {
            videoSrc != '' && window.modalSectionVideo && window.modalSectionVideo(videoSrc);
        } else {
            let url = '/ajax/action/catalog_section_digest/get_popup/';
            let time = new Date().getTime() + 400;
            window.mxLoader && window.mxLoader.show();

            $.ajax({
                url: url,
                data: {
                    id: sectId,
                    src: videoSrc
                },
                type: 'post',
                success: function(result) {
                    // Ограничение минимального времени загрузки формы
                    time = time - new Date().getTime();
                    time = time > 0 ? time : 0;

                    setTimeout(function() {
                        window.mxLoader && window.mxLoader.hide(0);
                        window.modalSectionVideo(result.html);
                    }, time);
                }
            });
        }
    });

    $(window).on('resize', function() {
        let element = document.querySelector('.jqi--digest-video');
        if (element) {
            let $player, player, width, originWidth, originHeight;
            player = element.querySelector('iframe');

            if (player) {
                $player = $(player);
                width = $player.width();
                originWidth = parseInt($player.attr('width')) || parseInt(player.style.width);
                originHeight = parseInt($player.attr('height')) || parseInt(player.style.height);
            }

            if (width && width > 0 && originWidth > 0 && originHeight > 0) {
                let ratio = originWidth / originHeight;
                let height = width / ratio;

                $player.css({ 'max-height': height + 'px' });
            }
        }
    });
});

// Метод для вызова всплывающего окна, содержащего iframe видео, размещенного на youtube,
// либо локальный видеофайл, обернутый в верстку штатного видеоплеера Битрикс
window.modalSectionVideo = function(source) {
    window.mxLoader = window.mxLoader || undefined;

    $.prompt(source, {
        classes: {
            prompt: 'jqi--width-by-content jqi--digest-video'
        }
    });

    $(window).trigger('resize');
};



// WEBPACK FOOTER //
// ./blocks/digest/digest.js